'use client'

import { RM } from '@request-metrics/browser-agent'

if (process.env.NEXT_PUBLIC_REQUEST_METRICS_TOKEN) {
    RM.install({ token: process.env.NEXT_PUBLIC_REQUEST_METRICS_TOKEN })
}

export {}
